module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('label', [_vm._v("文件：")]), _c('vbl-upload', {
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v("上传文件")])], 1), _c('div', {
    staticClass: "form-row"
  }, [_c('label', [_vm._v("文件(可以上传多个)：")]), _c('vbl-upload', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v("上传文件")])], 1), _c('div', [_vm._v("\n        注：现在只是上传文件的交互，上传图片的交互还没有添加！\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f76daaa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblUpload/example/vblUploadExample.vue
// module id = 245
// module chunks = 0